<template>
    <v-list>
        <v-list-tile
                v-if="getProfile.id_company !== 62"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/access/0">
            <v-list-tile-action>
                <v-icon medium>compare_arrows</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('entradas_salidas')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
            v-else
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/check_in_out_employees">
            <v-list-tile-action>
                <v-icon medium>compare_arrows</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('entradas_salidas')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/waiting_room">
            <v-list-tile-action>
                <v-icon medium>living</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('waiting_room')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
            v-if="getProfile.is_cav_active && getProfile.enable_shipments"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/shipment_weigh_queue">
            <v-list-tile-action>
                <v-icon medium>scale</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>{{$t('pesajes')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/registro_usuario">
            <v-list-tile-action>
                <v-icon medium>person_add_alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('registrar_usuario')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-show="getProfile.enable_school"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/access_tutors">
            <v-list-tile-action>
                <v-icon medium>supervised_user_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('access_to_tutors')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-show="getProfile.id_company === 62"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/acceso_sin_codigo">
            <v-list-tile-action>
                <v-icon medium>input</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('acceso_sin_codigo')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/bitacora">
            <v-list-tile-action>
                <v-icon medium>date_range</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Historial')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/bitacora_empresa">
            <v-list-tile-action>
                <v-icon medium>work_history</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Historial_Empleados')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/my-documents">
            <v-list-tile-action>
                <v-icon medium>description</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>Mis Documentos</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/guard-messages">
            <v-list-tile-action>
                <v-icon medium>notifications</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>Mis Comunicados</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-show="getProfile.id_company !== 62"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/current_invitations">
            <v-list-tile-action>
                <v-icon medium>event</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('current_invitations')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/ayuda_admin">
            <v-list-tile-action>
                <v-icon medium>help</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('Ayuda')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
    </v-list>
</template>

<script>
    import { get } from 'core-js/core/dict';
import { mapGetters } from 'vuex'

    export default {
        name: "Guardia",
        computed: {
            ...mapGetters(['getProfile'])
        }
    }
</script>

<style scoped>
.tile {
  cursor: pointer;
}
</style>
